import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { forwardHumanEvents } from "./Comps/VisitorTracker";

// The client spiral is a self-contained WebGL page (public/pages/clientele.html).
// It owns the whole window's scroll and wheel input, so it runs in a full-screen
// iframe instead of inside the site's layout.
// The iframe is portalled to <body>: the route fade transition puts a transform on
// the page wrapper, which would collapse a fixed iframe to zero height, and the
// spiral's layout never finishes at zero height (it freezes the tab).
// The route transition briefly mounts two copies of this page, so the scroll lock
// is counted and only released when the last copy unmounts.
let openCount = 0;

const Clientele = () => {
  useEffect(() => {
    openCount += 1;
    document.body.style.overflow = "hidden";
    return () => {
      openCount -= 1;
      if (openCount === 0) document.body.style.overflow = "";
    };
  }, []);

  return createPortal(
    <div className="clientele-page">
      <iframe
        className="clientele-frame"
        src="/pages/clientele.html"
        title="Clientele – brands I have worked with"
        onLoad={(e) => forwardHumanEvents(e.currentTarget.contentWindow)}
      />
      <Link to="/Archive" className="clientele-back">
        ← Archive
      </Link>
    </div>,
    document.body
  );
};

Clientele.displayName = "Clientele";

export default Clientele;
